import React, { useEffect, useRef, useState } from "react";
import { apiUrl } from "../../commons/inFormTypes";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const GoogleLoginButton = ({ text = "signin_with", redirectTo = "/user/dashboard" }) => {
    const btnRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const { isEnglish } = useLanguage();

    useEffect(() => {
        const controller = new AbortController();
        let timer;
        setError(false);
        btnRef.current?.replaceChildren();
        const handleCredential = async (response) => {
            try {
                const res = await fetch(apiUrl + "auth/GoogleSignIn", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ credential: response.credential }),
                });

                if (res.ok) {
                    const data = await res.json();
                    const cookies = new Cookies();
                    cookies.set("token", data.token, { path: "/" });
                    cookies.set("role", data.role, { path: "/" });
                    if (data.role === "Admin") {
                        navigate(redirectTo || "/mainadmin/users");
                    } else {
                        navigate(redirectTo || "/user/dashboard");
                    }
                } else {
                    setError(true);
                }
            } catch {
                setError(true);
            }
        };

        const initialize = async () => {
            try {
                const response = await fetch(apiUrl + "auth/GoogleConfig", { signal: controller.signal, cache: "no-store" });
                if (!response.ok) throw new Error("Google configuration unavailable");
                const { clientId } = await response.json();
                if (typeof clientId !== "string" || !clientId.trim()) throw new Error("Missing Google client ID");
                if (controller.signal.aborted) return;

                let attempts = 0;
                timer = setInterval(() => {
                    attempts += 1;
                    if (window.google?.accounts?.id && btnRef.current) {
                        clearInterval(timer);
                        window.google.accounts.id.initialize({
                            client_id: clientId.trim(),
                            callback: handleCredential,
                            auto_select: false,
                            cancel_on_tap_outside: true,
                        });
                        window.google.accounts.id.renderButton(btnRef.current, {
                            type: "standard",
                            theme: "outline",
                            size: "large",
                            text,
                            shape: "rectangular",
                            width: Math.min(btnRef.current.offsetWidth || 320, 400),
                        });
                        return;
                    }
                    if (attempts >= 20) {
                        clearInterval(timer);
                        setError(true);
                    }
                }, 250);

            } catch {
                if (!controller.signal.aborted) setError(true);
            }
        };
        initialize();

        return () => {
            controller.abort();
            clearInterval(timer);
        };
    }, [isEnglish, navigate, redirectTo, text]);

    return (
        <div className="flex flex-col items-center w-full">
            {error && <p role="alert">{isEnglish ? "Google sign-in is unavailable. Please try again later." : "ورود با گوگل انجام نشد. لطفاً دوباره تلاش کنید."}</p>}
            <div ref={btnRef} className="flex w-full justify-center"></div>
        </div>
    );
};

export default GoogleLoginButton;
